"use client";

import * as React from "react";

import type { CtaLocation } from "@/lib/cta-tracking";

const CtaLocationContext = React.createContext<CtaLocation>("body");

/**
 * Declares where on the page the links beneath it sit, so `Link` can tag
 * conversion CTAs with `cta_location`. Defaults to "body".
 */
function CtaLocationProvider({
  location,
  children,
}: {
  location: CtaLocation;
  children: React.ReactNode;
}) {
  return (
    <CtaLocationContext.Provider value={location}>
      {children}
    </CtaLocationContext.Provider>
  );
}

function useCtaLocation() {
  return React.useContext(CtaLocationContext);
}

export { CtaLocationProvider, useCtaLocation };
